import axios, { AxiosResponse } from 'axios'
import jwtDecode from 'jwt-decode'
import { storageTokensKey } from './keys'

export interface TokensType {
  refreshToken: string
  accessToken: string
  expiring: number
}

const saveTokens = (response: AxiosResponse): TokensType => {
  const refreshToken = response.headers['x-refresh-token']
  const accessToken = response.headers['x-access-token']

  const token = jwtDecode(accessToken) as any

  const tokens: TokensType = {
    refreshToken,
    expiring: token.exp * 1000,
    accessToken,
  }

  localStorage.setItem(storageTokensKey, JSON.stringify(tokens))
  return tokens
}

const refreshTokens = async (tokens: TokensType): Promise<TokensType> => {
  const response = await axios.put(
    '/auth',
    { headers: { 'Content-Type': 'application/json' } },
    {
      headers: {
        'X-REFRESH-TOKEN': tokens.refreshToken,
      },
    }
  )

  return saveTokens(response)
}

const isAccessTokenAboutToExpire = (tokens: TokensType): boolean => {
  let currentDate = new Date()
  if (tokens.expiring < currentDate.getTime()) {
    refreshTokens(tokens)
    console.log('Token expired.')
    return false
  }

  console.log('Valid token')
  return true
}

export { saveTokens, isAccessTokenAboutToExpire }
